import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Business from './pages/Business';
import Person from './pages/Person';
import Email from './pages/Email';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/business' exact component={Business} />
        <Route path='/person' exact component={Person} />
        <Route path='/email' exact component={Email} />
      </Switch>
    </BrowserRouter>
  );
}